// components/CategoryCard.jsx
import { Link } from "react-router-dom";

export const CategoryCard = ({ title, imageSrc, to }) => {
  const cardContent = (
    <>
      <div className="mx-auto  w-[86%] relative aspect-square  mb-3 overflow-hidden rounded-lg">
        <img
          src={imageSrc}
          alt={title}
          className="w-[90%] mx-[auto] h-full transition-transform duration-300 group-hover:scale-110"
        />
      </div>
      <h3 className="text-center font-medium text-[#B36C5E] font-itim transition-transform duration-300 group-hover:scale-110">
        {title}
      </h3>
    </>
  );

  if (to) {
    return (
      <Link to={to} className="group cursor-pointer block">
        {cardContent}
      </Link>
    );
  }

  return <div className="group cursor-pointer">{cardContent}</div>;
};

export default CategoryCard;
